import { Typography } from '@mui/material';

import { GDMTypographyComponent } from './GDMTypography.type';

/* TODO: Implement component using GDM default design */
const GDMTypography: GDMTypographyComponent = props => <Typography {...props} />;

export default GDMTypography;
